import classnames from "classnames";
import React, { useEffect, useState } from "react";
import "./VideoAssetViewer.css";

import { ShakaMediaPlayer } from "./ShakaMediaPlayer";

interface IVideoAssetViewerProps {
  asset: IAsset;
  lng?: string;
}

const VideoAssetViewer = ({ asset, lng }: IVideoAssetViewerProps) => {
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    async function loadAsset() {
      if (!asset) {
        setLoading(false);
        return;
      }

      const image = new Image();
      image.src = asset.media.large;
      image.onload = (_event) => {
        setLoading(false);
      };
    }

    loadAsset();
  }, [asset]);

  if (!asset) {
    return null;
  }

  if (isLoading) {
    return null;
  }

  return render(asset, lng);
};

export function render(asset: IAsset, _lng?: string) {
  const classNames = classnames(
    "mv-asset-viewer__asset",
    "mv-asset-viewer__asset--video"
  );

  if (!asset.media.streamingManifest) {
    return null;
  }

  return (
    <div className="mv-asset-viewer mv-asset-viewer__container">
      <div className={classNames}>
        <ShakaMediaPlayer
          key={asset.id}
          stream={asset.media.streamingManifest}
        />
      </div>
    </div>
  );
}

export default VideoAssetViewer;
